import React from 'react'
import { FormattedMessage, IntlShape, useIntl } from 'react-intl'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../styles'
import classNames from 'classnames'
import { ButtonBase, Theme } from '@material-ui/core'
import iconsEnum from '../../enums/iconsEnum'
import IconNumberComponent from './IconNumberComponent'
import { YfManagerModel } from '../../types/yfPopin/yfManagerModel'
import { useMediaQuery } from 'react-responsive'
import { displayModal } from '../reducers/modal/actions'
import { connect } from 'react-redux'
import { modalTypes } from '../../enums/modalTypeEnum'
import links from '../../enums/linksEnum'
import { useHistory } from 'react-router'
import { defaultYfDisplay } from '../../enums/yfManagerEnums'

const useStyle = makeStyles<Theme, { youfirstManager: YfManagerModel }>((theme) => ({
		...styles(theme),
		yfDetailsDiv: {
			display: 'flex',
			flexDirection: 'column',
			width: '100%'
		},
		largeHeaderDiv: {
			display: 'flex',
			boxSizing: 'border-box',
			backgroundImage: props => `url('${props.youfirstManager.picture === defaultYfDisplay ? 'img/yfm_img/defaultYFM.png' : props.youfirstManager.picture}')`,
			backgroundSize: 'contain',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'right bottom',
			borderTopLeftRadius: 40,
			borderTopRightRadius: 40,
			minHeight: 320
		},
		smallHeaderDiv: {
			backgroundSize: 'contain',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'right bottom',
			borderTopLeftRadius: 40,
			borderTopRightRadius: 40,
			marginBottom: '6%'
		},
		titleDiv: {
			width: '100%',
			marginTop: '6%',
			marginLeft: '6%',
			textAlign: 'left'
		},
		largeSubTitleDiv: {
			width: '46%'
		},
		smallSubTitleDiv: {
			display: 'flex',
			alignItems: 'flex-end',
			marginRight: '10%'
		},
		managerImgBackground: {
			width: 100
		},

		timeTableDiv: {
			marginTop: '10%'
		},
		yfManagerButtons: {
			flexDirection: 'row',
			justifyContent: 'center',
			height: 64,
			width: '100%',
			'& button': {
				width: '50%',
				height: '100%'
			}
		},
		blueButton: {
			backgroundColor: theme.palette.blue.main
		},
		greenButton: {
			backgroundColor: theme.palette.dynamic.main
		},
		yfManagerNumberDiv: {
			margin: '15px 35px'
		},

		yfManagerListNumber: {
			marginTop: '5%',
			columnCount: 2,
			columnGap: 58,
			breakInside: 'avoid'
		},

		subTitlePopIn: {
			marginLeft: '1%'
		},
		handleBreakLine: {
			whiteSpace: 'pre-line'
		}
	}
))

interface AcceptingProps {
	youfirstManager: YfManagerModel
	managerTitle: string,
	urgenceLabel: string
}

interface Store {
	displayModal: (modalType: string, content?: any) => void,
}

type YFManagerDetailsProps = AcceptingProps & Store

const YFManagerDetails: React.FC<YFManagerDetailsProps> = (
	{
		youfirstManager,
		managerTitle,
		urgenceLabel,
		displayModal
	}
) => {
	const classes = useStyle({ youfirstManager })
	const intl: IntlShape = useIntl()
	const history = useHistory()
	const isLargeHeightScreen = useMediaQuery(
		{
			query: '(min-height:800px)'
		}
	)

	const titleCoverClass = classNames(
		classes.colorBlue,
		classes.title2,
		isLargeHeightScreen ? '' : 'col-xs-12'
	)
	const timetableText = classNames(
		classes.text2,
		classes.colorBlue,
		classes.handleBreakLine,
		isLargeHeightScreen ? '' : 'col-xs-12'
	)
	const yfTextButton = classNames(
		classes.colorWhite,
		classes.title5,
		classes.handleBreakLine
	)
	const yfTitleNumber = classNames(
		classes.text4,
		classes.colorBlue,
		classes.heavy
	)
	const yfManagerListNumber = classNames(
		classes.yfManagerListNumber
	)

	const yfManagerNumberDivClass = classNames(
		classes.yfManagerNumberDiv
	)

	const yfManagerButtons = classNames(
		classes.yfManagerButtons
	)

	const headerDiv = classNames(
		isLargeHeightScreen ? classes.largeHeaderDiv : classes.smallHeaderDiv
	)

	const subTitleDiv = classNames(
		isLargeHeightScreen ? classes.largeSubTitleDiv : [classes.smallSubTitleDiv,'row']
	)

	const timeTableDiv = classNames({
		[classes.timeTableDiv]: isLargeHeightScreen
	})

	const goToDemandes = () => {
		history.push(links.requests)
	}

	const yfData = youfirstManager.data

	return (
		<div className={classes.yfDetailsDiv}>
			<div className={headerDiv}>
				<div className={classes.titleDiv}>
					<div className={subTitleDiv}>
						<span className={titleCoverClass}>
							{managerTitle}
						</span>
						{ isLargeHeightScreen ?
							<div className={timeTableDiv}>
								<span className={timetableText}>
				                	{yfData.horaires}
								</span>
							</div>
							:
							<span className={timetableText}>
								{yfData.horaires}
							</span>
						}
					</div>
				</div>
			</div>
			<div className={yfManagerButtons}>
				<ButtonBase className={classes.blueButton}>
                    <span
	                    className={yfTextButton}
                    >
                       {yfData.contact}
                    </span>
				</ButtonBase>
				<ButtonBase
					className={classes.greenButton}
					onClick={() => displayModal(modalTypes.demandes, { callback: goToDemandes })}
				>
                    <span className={yfTextButton}>
                       <FormattedMessage
	                       id="you_first_manager.sendMsg"
	                       defaultMessage="Envoyer un message"
	                       description="YF contact text"
                       />
                    </span>
				</ButtonBase>
			</div>
			<div className={yfManagerNumberDivClass}>
				<div>
					<span className={yfTitleNumber}>
	                   {urgenceLabel}
	                </span>
				</div>
				<div className={yfManagerListNumber}>
					{yfData.urgenceTech && <IconNumberComponent
						iconName={iconsEnum.Hotline}
						title={intl.formatMessage({
							id: 'you_first_manager.technical',
							defaultMessage: 'Urgence technique',
							description: 'Technical number'
						})}
						number={yfData.urgenceTech}
					/>}
					{yfData.chauffagiste && <IconNumberComponent
						iconName={iconsEnum.Heater}
						title={intl.formatMessage({
							id: 'you_first_manager.heating',
							defaultMessage: 'Chauffagiste',
							description: 'Heating engineer number'
						})}
						number={yfData.chauffagiste}
					/>}
					<IconNumberComponent
						iconName={iconsEnum.Faq2}
						title={intl.formatMessage({
							id: 'you_first_manager.emergency',
							defaultMessage: 'N° d’urgence',
							description: 'Emergency number'
						})}
						number={yfData.urgence} />
					{yfData.ascensoriste && <IconNumberComponent
						iconName={iconsEnum.Elevator}
						title={intl.formatMessage({
							id: 'you_first_manager.elevator',
							defaultMessage: 'Ascenseur',
							description: 'Elevator number'
						})}
						number={yfData.ascensoriste} />}
					{yfData.parking && <IconNumberComponent
						iconName={iconsEnum.Garage2}
						title={intl.formatMessage({
							id: 'you_first_manager.parking',
							defaultMessage: 'Portes de parking',
							description: 'Parking number'
						})}
						number={yfData.parking} />}
				</div>
			</div>
		</div>
	)
}

const mapDispatchToProps = {
	displayModal
}

export default connect(null, mapDispatchToProps)(YFManagerDetails)
